import invariant from 'ts-invariant'
import { domready } from './domready'

domready(function updateTokenInputsOnTokenChange() {
  document
    .querySelectorAll<HTMLSelectElement>('.js-token-select')
    .forEach(el => {
      el.addEventListener('change', () => {
        const selectedToken = el.value
        const targetSelector = el.dataset.tokenSelectTarget // using data-token-select-target attribute
        invariant(typeof targetSelector === 'string')

        document
          .querySelectorAll<HTMLInputElement>(targetSelector)
          .forEach(targetEl => (targetEl.value = selectedToken))
      })
    })
})
